/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Stack } from "@mui/material";
import { useSortableComponentList } from "cms/components/hooks/use-sortable-component-list";
import { AddLineWithIcon } from "components/add-line-with-icon";
import PositionButtons from "components/position-buttons";
import RemoveIcon from "components/remove-icon";
import { SortableContent } from "components/sortable-content";
import { ComponentCTAContext } from "./component-cta-context";

const defaultLink = Object.freeze({
    link: ""
});

/**
 * @param {object} props
 * @param {Link[]=} props.links
 * @param {(nextLinks: Link[]) => void} props.onChange
 * @param {import('react').ReactNode} props.children
 */
const ComponentCTAEditWrapper = (props) => {

    const {
        links: initialLinks = [],
        onChange,
        children
    } = props;

    const {
        list,
        sortableMethods,
        controls,
    } = useSortableComponentList(
        initialLinks,
        defaultLink,
        onChange
    );

    const { addNewItemBelow, removeItem } = controls;

    return (
        <div className='simplicity-image-list'>
            <Stack direction='column'>
                {list.map((link, index) => {
                    const { guid } = link;
                    const ctx = {
                        list,
                        index,
                        guid,
                        item: link,
                        position: index,
                        updateItems: onChange,
                        removeItem,
                    };

                    return (
                        <ComponentCTAContext.Provider key={`link-list-${guid}`} value={ctx}>
                            <SortableContent
                                id={guid}
                                index={index}
                                sortableMethods={sortableMethods}
                            >
                                {children}
                                <div>
                                    <PositionButtons
                                        index={index}
                                        list={list}
                                        handleUpdate={onChange}
                                    />
                                    <RemoveIcon
                                        className='simplicity-composer-field-editor-remove'
                                        onDeleteItem={removeItem}
                                        index={index}
                                    />
                                </div>
                            </SortableContent>
                            <AddLineWithIcon
                                index={index}
                                addNewItem={addNewItemBelow}
                            />
                        </ComponentCTAContext.Provider>
                    );
                })}
            </Stack>
        </div>
    );
};
ComponentCTAEditWrapper.displayName = "ComponentCTAEditWrapper";
export { ComponentCTAEditWrapper };

/**
 * @typedef {object} Link
 * @property {string} guid
 * @property {string} link
 * @property {number} position
 */
